class SlideshowAdaptive extends HTMLElement {
  connectedCallback() {
    this.slides  = Array.from(this.querySelectorAll('.sa-slide'));
    this.dots    = Array.from(this.querySelectorAll('.sa-dot'));
    this.current = 0;
    this.busy    = false;
    this.timer   = null;
    this.speed   = parseInt(this.dataset.speed, 10) || 5000;
    this.auto    = this.dataset.autoplay === 'true';

    if (this.slides.length < 2) return;

    this.querySelector('.sa-arrow--prev')
      ?.addEventListener('click', () => { this._stop(); this.go(this.current - 1); });
    this.querySelector('.sa-arrow--next')
      ?.addEventListener('click', () => { this._stop(); this.go(this.current + 1); });

    this.dots.forEach((d, i) =>
      d.addEventListener('click', () => { this._stop(); this.go(i); })
    );

    this._touch();
    if (this.auto) this._start();
  }

  disconnectedCallback() { this._stop(); }

  go(i) {
    if (this.busy) return;
    const n = ((i % this.slides.length) + this.slides.length) % this.slides.length;
    if (n === this.current) return;
    this.busy = true;

    this.slides[this.current].classList.remove('sa-slide--active');
    this.dots[this.current]?.classList.remove('sa-dot--active');

    this.current = n;
    this.slides[this.current].classList.add('sa-slide--active');
    this.dots[this.current]?.classList.add('sa-dot--active');

    setTimeout(() => { this.busy = false; }, 550);
  }

  _start() {
    this._stop();
    this.timer = setInterval(() => this.go(this.current + 1), this.speed);
  }

  _stop() { clearInterval(this.timer); this.timer = null; }

  _touch() {
    let x0 = 0, y0 = 0;
    this.addEventListener('touchstart', e => {
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });
    this.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - x0;
      const dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 44) {
        this._stop();
        this.go(dx < 0 ? this.current + 1 : this.current - 1);
      }
    }, { passive: true });
  }
}

if (!customElements.get('slideshow-adaptive')) {
  customElements.define('slideshow-adaptive', SlideshowAdaptive);
}